import TarefaPage from './pages/TarefaPage.vue';

const routes = [
  {
    path: 'ctrl-tarefas',
    name: 'ctrl-tarefas',
    component: TarefaPage
  }
];

export default routes;
